import {
	updateUserLanguage,
	authenticateUser,
	authenticateLdapUser,
	getActiveUser,
	logout,
	updateUserAvatar,
} from 'src/actions/userActions';

export const REQUEST_ACTIVE_USER = 'request_active_user';
export const RECEIVE_ACTIVE_USER = 'receive_active_user';
export const ACTIVE_USER_ERROR = 'active_user_error';

export const REQUEST_AUTHENTICATE_USER = 'request_authenticate_user';
export const RECEIVE_AUTHENTICATE_USER = 'receive_authenticate_user';
export const AUTHENTICATE_USER_ERROR = 'authenticate_user_error';

export const REQUEST_UPDATE_SELF = 'request_update_self';
export const RECEIVE_UPDATE_SELF = 'receive_update_self';
export const UPDATE_SELF_ERROR = 'update_self_error';

export const SET_SESSION_INFO = 'set_session_info';
export const REQUEST_LOGOUT_USER = 'request_logout_user';
export const RECEIVE_LOGOUT_USER = 'receive_logout_user';
export const LOGOUT_USER_ERROR = 'logout_user_error';

const getActiveUserRedux = () => async (dispatch) => {
	const onRequest = () => {
		// dispatch request string to be handled by reducer
		dispatch({
			type: REQUEST_ACTIVE_USER,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_ACTIVE_USER,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dispatch error string and payload to be handled by reducer
			type: ACTIVE_USER_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		let users = await getActiveUser();
		if (!users || users.length === 0) {
			logout();
			users = {};
			// return onError("Active user found, but not authenticated: Logout initiated");
		}
		return onSuccess(users);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const authenticateUserRedux =
	(username, password, ldap = false) =>
	async (dispatch) => {
		const onRequest = () => {
			// dispatch request string to be handled by reducer
			dispatch({
				type: REQUEST_AUTHENTICATE_USER,
			});
		};
		const onSuccess = (success) => {
			dispatch({
				// dispatch receive string and payload to be handled by reducer
				type: RECEIVE_AUTHENTICATE_USER,
				payload: success,
			});
			return success;
		};
		const onError = (error) => {
			dispatch({
				// dispatch error string and payload to be handled by reducer
				type: AUTHENTICATE_USER_ERROR,
				payload: error,
			});
			return { error };
		};
		try {
			onRequest();
			// make api call
			let users;
			if (ldap) {
				users = await authenticateLdapUser(username, password);
			} else {
				users = await authenticateUser(username, password);
			}
			return onSuccess(users);
		} catch (error) {
			console.log(error);
			return onError(error);
		}
	};

const sessionInfoRedux = (session) => async (dispatch) => {
	const onSuccess = (success) => {
		dispatch({
			type: SET_SESSION_INFO,
			payload: success,
		});
		return success;
	};

	try {
		return onSuccess(session);
	} catch (error) {
		console.log(error);
	}
};

const logoutActiveUser = (userId) => async (dispatch) => {
	const onRequest = () => {
		// dispatch request string to be handled by reducer
		dispatch({
			type: REQUEST_LOGOUT_USER,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_LOGOUT_USER,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dispatch error string and payload to be handled by reducer
			type: LOGOUT_USER_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const success = await logout(userId);
		return onSuccess(success);
	} catch (error) {
		console.log(error);
		return onError(error);
	}
};

const updateUserAvatarRedux = (userId, avatar) => async (dispatch) => {
	const onRequest = () => {
		// dispatch request string to be handled by reducer
		dispatch({
			type: REQUEST_UPDATE_SELF,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_UPDATE_SELF,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dispatch error string and payload to be handled by reducer
			type: UPDATE_SELF_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const users = await updateUserAvatar(userId, avatar);

		return onSuccess(users);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

const updateUserLanguageRedux = (userId, language) => async (dispatch) => {
	const onRequest = () => {
		// dispatch request string to be handled by reducer
		dispatch({
			type: REQUEST_UPDATE_SELF,
		});
	};
	const onSuccess = (success) => {
		dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_UPDATE_SELF,
			payload: success,
		});
		return success;
	};
	const onError = (error) => {
		dispatch({
			// dispatch error string and payload to be handled by reducer
			type: UPDATE_SELF_ERROR,
			payload: error,
		});
	};
	try {
		onRequest();
		// make api call
		const users = await updateUserLanguage(userId, language);

		return onSuccess(users);
	} catch (error) {
		console.log(error);

		return onError(error);
	}
};

const logoutAnyUser = () => async (dispatch) => {
	try {
		await logout();
		return dispatch({
			// dispatch receive string and payload to be handled by reducer
			type: RECEIVE_LOGOUT_USER,
			payload: 'logout',
		});
	} catch (error) {
		console.log('logoutAnyUser Error', error);
	}
};

export {
	sessionInfoRedux,
	logoutActiveUser,
	updateUserLanguage,
	updateUserLanguageRedux,
	updateUserAvatarRedux,
	authenticateUserRedux,
	getActiveUserRedux,
	logoutAnyUser,
};
